import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from "../../material/material.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterStepperComponent } from './register-stepper/register-stepper.component';
import { SignatureFormComponent } from './signature-form/signature-form.component';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { AddIndividualOwnerComponent } from './register-vertical/add-individual-owner/add-individual-owner.component';
import { AddPropertyManagmentCompanyComponent } from './register-vertical/add-property-managment-company/add-property-managment-company.component';
import { AddHotelMotelComponent } from './register-vertical/add-hotel-motel/add-hotel-motel.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { ManagementCompanyAddComponent } from './management-company-add/management-company-add.component';
import { OwnerCompanyAddComponent } from './owner-company-add/owner-company-add.component';
import { EntitylicensestepComponent } from './register-vertical/shared/entitylicensestep/entitylicensestep.component';
import { RentalPropertyLicenseComponent } from './register-vertical/shared/rental-property-license/rental-property-license.component';
import { RentalPropertyComponent } from './register-vertical/shared/rental-property/rental-property.component';
import { AddressFormComponent } from './register-vertical/shared/address-form/address-form.component';
import { RentalPropertyReportingFormComponent } from './register-vertical/shared/rental-property-reporting-form/rental-property-reporting-form.component';
import { AgreementsComponent } from './register-vertical/shared/agreements/agreements.component';
import { StepCompleteComponent } from './register-vertical/shared/step-complete/step-complete.component';
import { PrintPageComponent } from './register-vertical/print-page/print-page.component';
import { TaxCertificateNumberDirective } from '../../directives/tax-number-input.directive';
import { PhoneFormatDirective } from '../../directives/phone-format.directive';
import { HeaderBannerComponent } from '../../shared/header-banner/header-banner.component';



@NgModule({
  declarations: [
    RegisterStepperComponent,
    SignatureFormComponent,
    DialogConfirmComponent,
    AddIndividualOwnerComponent,
    AddPropertyManagmentCompanyComponent,
    AddHotelMotelComponent,
    CreateAccountComponent,
    ManagementCompanyAddComponent,
    OwnerCompanyAddComponent,
    EntitylicensestepComponent,
    RentalPropertyLicenseComponent,
    RentalPropertyComponent,
    AddressFormComponent,
    RentalPropertyReportingFormComponent,
    AgreementsComponent,
    StepCompleteComponent,
    PrintPageComponent,
  ],
  exports: [
    RentalPropertyReportingFormComponent,
    EntitylicensestepComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TaxCertificateNumberDirective,
    PhoneFormatDirective
  ]
})

export class RegisterStepperModule { };